import { useEffect, useState } from "react"
import { DataListType, FilterStateType } from "../types";
import { useApi } from "utils";
import { SuccessFetch } from "types";

export function useListRegister({ department, jobpos,  keyword, shift_schedule_id, divisi }: FilterStateType) {

  const api = useApi()
  const [data, setData] = useState<DataListType[]>([])
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {};
  if (department) params.department_id = department;
  if (jobpos) params.jobpos = jobpos;
  if (divisi) params.divisi_id = divisi;
  if (shift_schedule_id) params.shift_schedule_id = shift_schedule_id;
  if (keyword) params.search = keyword;


  const fetchingData = () => api.get("/employee/data_schedule_by_id", { params })
  const fetchData = () => {
    setLoading(true)

    fetchingData()
    .then((res: SuccessFetch<{ payload: DataListType[] }>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }
  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [ department, jobpos, location, shift_schedule_id, keyword, divisi ])

  return { data, isLoading, refetch }
}